/* eslint-disable complexity */
import React from "react";

import { useCountriesOrRegionsList } from "../../../../helpers/countriesOrRegionsList";
import { DropdownOption } from "../../../../helpers/optionSets";
import { IntroBusinessContactCustomerDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyBusinessContactCustomerProps = {
  dataInForm: IntroBusinessContactCustomerDataType;
};

const businessContactCustomerConfig: Map<string, ReadOnlyFormItem> = new Map([
  [
    "businessContactCustomerCountryOrRegion",
    {
      title: "countryOrRegion",
      mapper: (
        data: IntroBusinessContactCustomerDataType,
        _localizedStrings: Map<string, string>,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        additionalData?: Map<string, any>
      ) => {
        if (!additionalData) {
          return null;
        }
        const countriesOrRegionsList = additionalData.get(
          "countriesOrRegionsList"
        ) as Array<DropdownOption>;
        const selectedCountryCode = data.businessContactCustomerCountryOrRegion;
        for (const country of countriesOrRegionsList) {
          if (country.value === selectedCountryCode) {
            return country.label;
          }
        }
        return "";
      },
    },
  ],
  [
    "businessContactCustomerAddressLine1",
    {
      title: "businessAddress",
      mapper: (data: IntroBusinessContactCustomerDataType) => {
        if (
          !data.businessContactCustomerAddressLine1 &&
          !data.businessContactCustomerAddressLine2
        ) {
          return "";
        }
        if (!data.businessContactCustomerAddressLine2) {
          return data.businessContactCustomerAddressLine1;
        }
        return `${data.businessContactCustomerAddressLine1} </br> ${data.businessContactCustomerAddressLine2}`;
      },
      isAnswerWithHtmlContent: true,
    },
  ],
  ["businessContactCustomerCity", { title: "city" }],
  ["businessContactCustomerStateRegion", { title: "stateRegion" }],
  ["businessContactCustomerPostalCode", { title: "postalCode" }],
  ["businessContactCustomerPhone", { title: "phone" }],
]);

export const ReadOnlyBusinessContactCustomer = ({
  dataInForm,
}: ReadOnlyBusinessContactCustomerProps) => {
  const countriesOrRegionsList = useCountriesOrRegionsList();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const additionalData = new Map<string, any>([["countriesOrRegionsList", countriesOrRegionsList]]);

  return (
    <ReadOnlyForm
      formConfig={businessContactCustomerConfig}
      formData={dataInForm}
      additionalData={additionalData}
    />
  );
};
